import { Button } from "@runcheetah/ui";

import { BRAND_DETAIL_SECTIONS, type BrandDetailSection } from "./sections";

export function BrandDetailSectionTabs({
  activeSection,
  onSectionChange,
}: {
  activeSection: BrandDetailSection;
  onSectionChange: (section: BrandDetailSection) => void;
}) {
  return (
    <div className="flex w-full min-w-0 gap-2 overflow-x-auto border-b border-border/70 pb-3">
      {BRAND_DETAIL_SECTIONS.map((section) => (
        <Button
          key={section.key}
          variant={activeSection === section.key ? "default" : "ghost"}
          size="sm"
          className="shrink-0 rounded-full"
          onClick={() => onSectionChange(section.key)}
        >
          {section.label}
        </Button>
      ))}
    </div>
  );
}
